import { useMemo } from 'react'

import { ModalContext } from '@domain-group/suit-theme'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'

import PageContext from '@contexts/pageContext'
import type { PageContextPayload } from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import CreateOrEditSuburbModal from '@modals/CreateOrEditSuburbModal'

import PageContent from './components/PageContent'

type DefaultState = {
  showCreateOrEditSuburbModal: boolean,
}

const defaultState = {
  showCreateOrEditSuburbModal: false,
}

const callbacks = (component: string, setState: (state: Partial<DefaultState>) => void) => {
  const componentCallbacks = {
    CreateOrEditSuburbModal: {
      closeModal: () => setState({ showCreateOrEditSuburbModal: false }),
      createGeoSuburb: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
      updateGeoSuburb: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  // @ts-expect-error TS7053
  return componentCallbacks[component] || {}
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const {
    showCreateOrEditSuburbModal,
  } = state

  const modalContext = useModals({ setState })
  const {
    callbacks: { setModalData },
  } = modalContext

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    pageFilters,
  } = useFilters()

  const pageContext: PageContextPayload = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      showCreateOrEditSuburbModal: (payload: object) => {
        setModalData('CreateOrEditSuburbModal', payload)
        setState({ showCreateOrEditSuburbModal: true })
      },
    },
    defaultFilters,
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent pageFilters={pageFilters} />

        {/*
         // @ts-expect-error TS2741 */}
        <CreateOrEditSuburbModal
          callbacks={callbacks('CreateOrEditSuburbModal', setState)}
          showModal={showCreateOrEditSuburbModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
